'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { PackStandardVirtuelCard } from './PackStandardVirtuelCard';
import { PackFixeVoipCard } from './PackFixeVoipCard';

export function OffersSection() {
  const [isAnnual, setIsAnnual] = useState(false);

  return (
    <div className="flex flex-col items-center justify-center gap-8 w-full px-4 md:px-0">
      {/* Toggle Annuel/Mensuel */}
      <div className="flex items-center justify-center bg-lightGreen rounded-full p-2">
        <Button
          variant={!isAnnual ? 'primaryGreen' : 'ghost'}
          className="text-sm"
          onClick={() => setIsAnnual(false)}
        >
          Mensuel
        </Button>
        <Button
          variant={isAnnual ? 'primaryGreen' : 'ghost'}
          className="text-sm"
          onClick={() => setIsAnnual(true)}
        >
          Annuel (2 mois offerts)
        </Button>
      </div>

      {/* Blocs des 2 offres côte à côte */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 w-full max-w-6xl">
        <PackStandardVirtuelCard isAnnual={isAnnual} />
        <PackFixeVoipCard isAnnual={isAnnual} />
      </div>
    </div>
  );
}
